<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7j3BBv/tc-custom/9781600378423.jpg?1701918874354" alt="This image is the cover for the book Selling with Intention"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Selling with Intention
      </h1>
      <p class="bookDescription body article font2">
        <p>Every Sales Person and Entrepreneur knows that selling is the key to success, but most never achieve their potential even after attending numerous trainings and reading dozens of books. Why? Most of the training industry focuses on technique without ever addressing the most important part of the sales process – what the Sales Person is saying to themselves. It doesn’t matter how well you implement the concepts and methods if you haven’t addressed the beliefs and behaviors that are sabotaging your efforts. “How we think about selling makes all the difference.” In Selling With Intention, Sales Expert and Certified Sales Coach Ursula Mentjes shares the expertise she uses to help clients double their sales revenues in as short as two months. Her principles and exercises will help you: Transform the way you think about and interact with your target clients, the sales process, and yourself as a sales person; Develop the mindset, systems, and intentional sales plan you need to significantly increase sales; Let go of the fears and limiting beliefs that have been sabotaging your efforts; Move forward with a renewed sense of confidence in solving clients’ problems; and Take a quantum leap toward your greatest sales goals.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ursula C. Mentjes
      </h2>
      
      <p class="authorDescription body article">Ursula Mentjes, sought after motivational speaker and Certified Sales Coach, has trained thousands of Sales Professionals and Entrepreneurs, helping many to double and triple their sales revenue. Ursula honed her sales and executive management skills at an International Technical Training company where she advanced to the position of President in just five years when she was 27 years old and the company’s annual revenue was in the tens of millions. In 2004, Ursula launched her own sales coaching and training company that specializes in working with Entrepreneurs and Sales Professionals. Ursula holds a Bachelor of Arts Degree in Psychology and Communication and a Master of Science Degree in Psychology. She is a Certified NLP Coach through the NLP Institute of California, and an Associate Certified Coach through the International Coach Federation. Ursula is Past President of the National Association of Women Business Owners Inland Empire Chapter, Past President of the Inland Empire Women’s Education Foundation, Vice-President of Economic Development for the National Association of Women Business Owners of California, a founding member of the Business Resource Connection and the Director of Education, a 2006 Graduate of Leadership California, a 2007 Spirit of the Entrepreneur Finalist, named one of 951 Magazine’s 51 to Watch in 2008, and the recipient of the 2009 NAWBO-IE A.N.I.T.A. Award. She also serves on several non-profit boards that are near and dear to her heart. Ursula C. Mentjes, M.S., ACC Founder of Sales Coach Now www.SalesCoachNow.com www.MySalesCoachNow.com Contact@SalesCoachNow.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MJ New York
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?699d0380